import { apiErrorDetail } from '../../utils/apiError';

/**
 * Shared checkout error copy — extracted from UpgradeModal.tsx (2026-10-30)
 * so TopupModal doesn't fork a second copy of the same payment error
 * messages. `overrides` lets a caller supply its OWN wording for codes that
 * mean something different in its own flow (e.g. UpgradeModal's
 * `plan_not_purchasable`/`live_subscription_exists`), checked BEFORE the
 * shared defaults below.
 */
export function checkoutErrorMessage(err: any, overrides?: Record<string, string>): string {
  const status = err?.response?.status;
  const code = apiErrorDetail(err)?.code;

  if (code && overrides?.[code]) return overrides[code];

  if (code === 'invoicing_not_configured') {
    return 'Payments are paused while we finish our GST invoicing setup — please check back soon.';
  }
  if (status === 422 || code === 'plan_misconfigured') {
    return 'This is misconfigured on our end — please contact support.';
  }
  if (status === 502 || code === 'checkout_unavailable') {
    return 'Payment gateway is temporarily unavailable — please try again shortly.';
  }
  if (status === 503 || code === 'checkout_not_configured') {
    return 'Payments are not configured yet — please check back soon.';
  }
  return 'Something went wrong starting checkout. Please try again.';
}

/** Engine 422 codes from PUT /billing-profile, in words a lawyer can act on.
 *  Shared by UpgradeModal and TopupModal — both reuse BillingDetailsForm for
 *  the SAME billing_profile_required 409 branch. */
export const DETAILS_ERROR: Record<string, string> = {
  billing_name_invalid: 'Please enter the name to put on the invoice.',
  state_code_invalid: 'Please choose your state.',
  gstin_format: 'That GSTIN is not in the right format (15 characters, e.g. 27ABCDE1234F1Z5).',
  gstin_checksum: 'That GSTIN does not look right — please check each character.',
  gstin_state_unknown: 'That GSTIN does not start with a valid state code.',
  gstin_state_mismatch: 'That GSTIN is registered in a different state — please check the state you chose.',
  billing_address_required: 'Please enter your registered address — it is printed on a GST-registered invoice.',
  billing_address_invalid: 'That address is too long (500 characters at most).',
};
